import { Grid, Link, CircularProgress, Collapse, Alert } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { StateContext } from "../../App";
import { useContext, useEffect, useRef, useState } from "react";
import Api from "../../services/Api";
import { useOktaAuth } from "@okta/okta-react";
import text from "../../data/text";
import { Context } from "../../context/Context";

const classes = {
    alert: {
        backgroundColor: "green.main",
    },
    checkIcon: {
        color: "green.main",
        padding: "0",
        margin: "0",
    },
    iconBox: {
        backgroundColor: "#fce101",
        minHeight: "100%",
        width: "100%",
        paddingTop: 1,
        paddingBottom: 1,
    },
    resendCode: {
        marginLeft: 0.5,
        fontSize: "15px",
        paddingTop: "4px",
        paddingBottom: "3px",
        color: "inherit",
        // textDecoration: "none",
        "&:hover": {
            color: "linkHover.main",
            textDecoration: "underline",
        },
        "&:visited": {
            color: "linkVisited.main",
        },
    },
    resendIcon: {
        width: "80px",
        paddingTop: "3px",
        paddingBottom: "3px",
    },
    success: {
        position: "fixed",
        top: "40px",
        width: "300px",
        marginLeft: "-135px",
        left: "50%",
        zIndex: "1300",
    },
    warning: {
        marginBottom: 2,
        padding: "8px 8px 8px 8px",
        backgroundColor: "#fce101",
        borderRadius: "4px",
        fontSize: "15px",
    },
    warningIcon: {
        color: "#bf8004",
    },
};

function Warning(props) {
    const [resendOtpStatus, setResendOtpStatus] = useState("link"); //link || loading || success
    const { state } = useContext(StateContext);
    const { locale } = useContext(Context);
    const language = locale === "fr" ? "french" : "english";
    const { authState } = useOktaAuth();
    // const linkRef = useRef();

    useEffect(() => {
        // if (resendOtpStatus == "link" && props.warning) {
        //     linkRef.current.focus();
        // }
        if (resendOtpStatus == "success") {
            setTimeout(() => {
                setResendOtpStatus("link");
            }, 6000);
        }
    }, [resendOtpStatus, props]);

    const resendOtp = async (e) => {
        e.preventDefault();
        setResendOtpStatus("loading");
        try {
            await Api.resendOtp(authState.accessToken.accessToken, {
                factorId: state.factorId,
            });
            setResendOtpStatus("success");
            return props.setError({
                state: false,
                text: "",
            });
        } catch (err) {
            setResendOtpStatus("link");
            if (err.response && err.response.data.errorCode == 9) {
                return props.setError({
                    state: true,
                    text: "error3",
                });
            }
        }
    };

    return (
        <Grid container role="alert" aria-live="assertive" sx={classes.warning}>
            <Grid
                item
                xs={2}
                sm={2}
                md={2}
                lg={2}
                xl={2}
                sx={classes.iconBox}
                container
                justifyContent="center"
                alignItems="center"
            >
                <HelpIcon sx={classes.warningIcon} />
            </Grid>
            <Grid
                item
                xs
                // item
                // xs={10}
                // sm={10}
                // md={10}
                // lg={10}
                // xl={10}
                container
                justifyContent="flex-start"
                alignItems="center"
            >
                <span>{text.content[language].errors.warning1}</span>
                {resendOtpStatus == "link" && (
                    <Link
                        component="button"
                        sx={classes.resendCode}
                        onClick={resendOtp}
                        aria-label="Resend code"
                        // ref={linkRef}
                    >
                        {text.content[language].errors.warning2}
                    </Link>
                )}
                {(resendOtpStatus == "loading" ||
                    resendOtpStatus == "success") && (
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        direction="row"
                        sx={classes.resendIcon}
                    >
                        <CircularProgress size={16} />
                    </Grid>
                )}
            </Grid>
            <Collapse in={resendOtpStatus == "success"} sx={classes.success}>
                <Alert severity="success" variant="filled" sx={classes.alert}>
                    {text.content[language].errors.success1}
                </Alert>
            </Collapse>
        </Grid>
    );
}

export default Warning;
